<template>
  <section id="partners" class="py-20 bg-gradient-to-b from-blue-50 to-white">
    <div class="container mx-auto px-4">
      <h2 class="text-3xl font-bold text-center mb-16 text-gray-800">{{ $t('partners.title') }}</h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl mx-auto">
        <div class="flex items-center justify-center bg-white/80 backdrop-blur-sm p-8 rounded-lg shadow-sm hover:shadow-md transition-all duration-300">
          <img src="../assets/img/partner/1.jpg" :alt="$t('partners.items.partner1')" class="h-20 transition-all duration-300">
        </div>
        <div class="flex items-center justify-center bg-white/80 backdrop-blur-sm p-8 rounded-lg shadow-sm hover:shadow-md transition-all duration-300">
          <img src="../assets/img/partner/2.jpg" :alt="$t('partners.items.partner2')" class="h-20 transition-all duration-300">
        </div>
        <div class="flex items-center justify-center bg-white/80 backdrop-blur-sm p-8 rounded-lg shadow-sm hover:shadow-md transition-all duration-300">
          <img src="../assets/img/partner/3.jpg" :alt="$t('partners.items.partner3')" class="h-20 transition-all duration-300">
        </div>
        <div class="flex items-center justify-center bg-white/80 backdrop-blur-sm p-8 rounded-lg shadow-sm hover:shadow-md transition-all duration-300">
          <img src="../assets/img/partner/4.jpg" :alt="$t('partners.items.partner4')" class="h-20 transition-all duration-300">
        </div>
        <div class="flex items-center justify-center bg-white/80 backdrop-blur-sm p-8 rounded-lg shadow-sm hover:shadow-md transition-all duration-300">
          <img src="../assets/img/partner/5.jpg" :alt="$t('partners.items.partner5')" class="h-20 transition-all duration-300">
        </div>
        <div class="flex items-center justify-center bg-white/80 backdrop-blur-sm p-8 rounded-lg shadow-sm hover:shadow-md transition-all duration-300">
          <img src="../assets/img/partner/6.jpg" :alt="$t('partners.items.partner6')" class="h-20 transition-all duration-300">
        </div>
      </div>
    </div>
  </section>
</template> 